import React from 'react';
import { Helmet } from 'react-helmet-async';
import CustomSoftwareDev from '../components/CustomSoftwareDev';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://wayug.com/' },
    { '@type': 'ListItem', position: 2, name: 'Custom Software Development', item: 'https://wayug.com/custom-software-development' },
  ],
};

const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Custom Software Development Services',
  provider: {
    '@type': 'Organization',
    name: 'Wayug Infotech Solutions',
    url: 'https://wayug.com',
  },
  areaServed: 'India',
  description: 'Custom software development services in Delhi NCR. Web application development, Android/iOS mobile apps, custom ERP, CRM, and cloud engineering.',
};

export default function CustomSoftwareDevPage() {
  return (
    <div className="page-content subpage-content">
      <Helmet>
        <title>Custom Software Development Company Delhi NCR | Web &amp; Apps – Wayug</title>
        <meta
          name="description"
          content="Leading custom software development company in Delhi NCR. We build custom websites, Android/iOS mobile apps, ERPs, CRMs &amp; bespoke software solutions for clients."
        />
        <link rel="canonical" href="https://wayug.com/custom-software-development" />
        <meta property="og:title" content="Custom Software Development Company Delhi NCR | Wayug Infotech" />
        <meta
          property="og:description"
          content="Engineering bespoke software solutions for startups &amp; enterprises. Custom websites, mobile apps, ERP, CRM, and cloud engineering."
        />
        <meta property="og:url" content="https://wayug.com/custom-software-development" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(serviceSchema)}</script>
      </Helmet>
      <CustomSoftwareDev />
    </div>
  );
}
